/**
 * Enable Compliance Type Use Case
 */

import {
  ComplianceTypeEntity,
  EnabledComplianceTypeEntity,
} from "../../../../../compliance/domain/entities";
import { TenantComplianceRepository } from "../../../../../compliance/domain/repositories";

export class EnableTypeUseCase {
  constructor(private repository: TenantComplianceRepository) {}

  async execute(type: ComplianceTypeEntity): Promise<EnabledComplianceTypeEntity> {
    return await this.repository.enableType(type);
  }
}

